import { Modal, ModalBody } from 'reactstrap'
import PropTypes from 'prop-types'
import Lottie from 'react-lottie'
import * as animationData from '../../../assets/76705-error-animation.json'

const WarningModal = ({ isModal, messageType, errorMessage, toggleWarningModal, messageTitle }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  const warningText = () => {
    if (messageType === 'failed_required') {
      return <p>Lütfen tüm zorunlu alanları eksiksiz ve doğru şekilde doldurunuz.</p>
    }
    if (messageType === 'failed_tc') {
      return <p>T.C. Kimlik Numarası 11 haneli olmalıdır.</p>
    }
    if (messageType === 'failed_phone') {
      return <p>Telefon numarası 5 ile başlayan 10 haneli olmalıdır. Lütfen kontrol edip tekrar deneyin.</p>
    }
    if (messageType === 'failed_agreement') {
      return <p>Başvuruyu tamamlamak için kullanım koşullarını kabul etmeniz gerekmektedir.</p>
    }
    if (messageType === 'failed_health') {
      return <p>Başvuruyu tamamlamak için sağlık beyanını onaylamanız gerekmektedir.</p>
    }
    if (messageType === 'server_error') {
      return <p>{errorMessage}</p>
    }
  }

  return (
    <div>
      <Modal centered isOpen={isModal} toggle={toggleWarningModal}>
        <ModalBody
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            lineHeight: 1,
          }}
        >
          <div style={{ with: '100%', marginBottom: '1rem', marginTop: '0.5rem' }}>
            <Lottie options={defaultOptions} height={75} width={75} />
          </div>
          <p
            style={{
              fontWeight: 'bolder',
              fontSize: 25,
            }}
          >
            {messageTitle ? messageTitle : 'Uyarı'}
          </p>
          <div style={{ textAlign: 'center' }}>{warningText()}</div>
        </ModalBody>
      </Modal>
    </div>
  )
}

WarningModal.propTypes = {
  isModal: PropTypes.bool,
  messageType: PropTypes.string,
  errorMessage: PropTypes.string,
  toggleWarningModal: PropTypes.func,
  messageTitle: PropTypes.string,
}

export default WarningModal
